import { render, staticRenderFns } from "./tenant_table.vue?vue&type=template&id=39596e84&"
import script from "./tenant_table.vue?vue&type=script&lang=js&"
export * from "./tenant_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports